import { render, staticRenderFns } from "./DisplayKindKollekteApp.vue?vue&type=template&id=5ea9408e&scoped=true&"
import script from "./DisplayKindKollekteApp.vue?vue&type=script&lang=js&"
export * from "./DisplayKindKollekteApp.vue?vue&type=script&lang=js&"
import style0 from "./DisplayKindKollekteApp.vue?vue&type=style&index=0&id=5ea9408e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9408e",
  null
  
)

export default component.exports